import { render, staticRenderFns } from "./RespProsp.vue?vue&type=template&id=0ab425ad"
import script from "./RespProsp.vue?vue&type=script&lang=js"
export * from "./RespProsp.vue?vue&type=script&lang=js"
import style0 from "./RespProsp.vue?vue&type=style&index=0&id=0ab425ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports